import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";

  switch (params.trip) {
    case "October-2026":
      dates = "September 29 - October 13, 2026";
      break;
    case "trip":
      dates = "";
      break;
  }
  return (
    <div className={styles.backgroundPictureItaly}>
      <div className={styles.titleBox}>
        <h1>Visit the beautiful country of</h1>
        <p className={styles.title}>Italy</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>with all of its history, culture, and charm: </p>
          <p>
            Rome, Pompeii, Sorrento, the Amalfi Coast, and the island of Capri.
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
